import {
  UseMutationOptions,
  useMutation,
  useQueryClient,
} from "@tanstack/react-query";
import { FieldValues } from "react-hook-form";
import axiosAuth from "../../axiosAuth";
import { CURRICULUM_MASTER } from "../apiRoutes";

const mutateAddCurriculumMaster = async ({ data }: { data: FieldValues }) => {
  return await axiosAuth.post(CURRICULUM_MASTER, data);
};

const useAddCurriculumMasterMutation = (
  queryParams?: UseMutationOptions<
    any,
    Error,
    {
      data: FieldValues;
    },
    unknown
  >
) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: mutateAddCurriculumMaster,
    onSuccess: (data, variables, context) => {
      // Invalidate and refetch curriculum master queries
      queryClient.invalidateQueries({
        queryKey: ["curriculumMaster"],
        exact: false,
      });
      queryParams?.onSuccess?.(data, variables, context);
    },
    ...queryParams,
  });
};

export default useAddCurriculumMasterMutation;
